/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_173_TitleInputs */

const en_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lemon Cupcake`)
};

const ar_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كب كيك الليمون`)
};

const de_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zitronen-Cupcake`)
};

const es_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake de limón`)
};

const fr_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake au citron`)
};

const it_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake al limone`)
};

const ja_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レモンカップケーキ`)
};

const ko_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레몬 컵케이크`)
};

const pt_br_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupcake de Limão`)
};

const ru_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лимонный капкейк`)
};

const th_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัพเค้กเลมอน`)
};

const tr_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limonlu Cupcake`)
};

const zh_cn_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`柠檬纸杯蛋糕`)
};

const zh_tw_tree_type_173_title = /** @type {(inputs: Tree_Type_173_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檸檬杯子蛋糕`)
};

/**
* | output |
* | --- |
* | "Lemon Cupcake" |
*
* @param {Tree_Type_173_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_173_title = /** @type {((inputs?: Tree_Type_173_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_173_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_173_title(inputs)
	if (locale === "ar") return ar_tree_type_173_title(inputs)
	if (locale === "de") return de_tree_type_173_title(inputs)
	if (locale === "es") return es_tree_type_173_title(inputs)
	if (locale === "fr") return fr_tree_type_173_title(inputs)
	if (locale === "it") return it_tree_type_173_title(inputs)
	if (locale === "ja") return ja_tree_type_173_title(inputs)
	if (locale === "ko") return ko_tree_type_173_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_173_title(inputs)
	if (locale === "ru") return ru_tree_type_173_title(inputs)
	if (locale === "th") return th_tree_type_173_title(inputs)
	if (locale === "tr") return tr_tree_type_173_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_173_title(inputs)
	return zh_tw_tree_type_173_title(inputs)
});